function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Grid from "patternfly-react/dist/esm/components/Grid/Grid";
/**
 * TableGridCol Component for PatternFly
 */

const TableGridCol = (_ref) => {
  let {
    children,
    selected
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "selected"]);

  const classes = classNames('table-grid-pf-col', {
    active: selected
  });
  return React.createElement(Grid.Col, props, React.createElement("span", {
    className: classes
  }, children));
};

TableGridCol.propTypes = {
  /** Children nodes */
  children: PropTypes.node,

  /** Flag if the cell is selected */
  selected: PropTypes.bool
};
TableGridCol.defaultProps = {
  children: null,
  selected: false
};
export default TableGridCol;